import { TextInput, PasswordInput, Anchor, Title, Text, Container, Button, Flex, Card, Box } from "@mantine/core";
import axios from "axios";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "@mantine/form";
import { toast } from "react-hot-toast";
import useAuthStore from "@/store/useAuthStore";
import { APP_NAME } from "@/config";

export default function Join() {
  const navigate = useNavigate();
  const handleAuthInit = useAuthStore((state) => state.handleAuthInit);
  const [loading, setLoading] = useState(false);

  const form = useForm({
    initialValues: {
      username: "",
      password: "",
      email: "",
      name: "",
      phoneNumber: "",
    },
  });
  const handleSubmit = async (data) => {
    try {
      setLoading(true);
      const res = await axios({
        url: "/auth/local/register",
        method: "POST",
        data,
      });
      handleAuthInit(res.data.jwt);
    } catch (error) {
      console.log(error);
      toast.error("회원가입에 실패했습니다");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={(theme) => ({ backgroundColor: theme.fn.rgba(theme.colors.brand[0], 0.3) })}>
      <Container size="xs">
        <Flex direction="column" justify="center" h={window.innerHeight}>
          <Card withBorder shadow="md" p={30} radius="md">
            <Title order={2} weight={900} ta="center" mb="xs">
              <Text component="span" variant="gradient" gradient={{ from: "brand", to: "cyan" }} inherit>
                {APP_NAME}{" "}
              </Text>
              간편 회원가입
            </Title>
            <Text color="dimmed" size="sm" ta="center" mb="lg">
              회원가입을 위한 정보를 입력해주세요
            </Text>

            <form onSubmit={form.onSubmit(handleSubmit)}>
              <TextInput
                label="아이디"
                placeholder="아이디를 입력해주세요"
                required
                {...form.getInputProps("username")}
                autoComplete="username"
              />
              <PasswordInput
                label="비밀번호"
                placeholder="비밀번호를 입력해주세요"
                required
                {...form.getInputProps("password")}
                autoComplete="current-password"
              />
              <TextInput
                label="이메일 주소"
                placeholder="이메일을 입력해주세요"
                required
                {...form.getInputProps("email")}
                autoComplete="email"
                type="email"
              />
              <TextInput
                label="이름"
                placeholder="이름을 입력해주세요"
                required
                {...form.getInputProps("name")}
                autoComplete="name"
              />
              <TextInput
                label="전화번호"
                placeholder="전화번호를 입력해주세요"
                required
                {...form.getInputProps("phoneNumber")}
                autoComplete="phoneNumber"
                type="tel"
              />

              <Button mt="sm" sx={{ float: "right" }} type="submit" loading={loading}>
                회원가입하기
              </Button>
            </form>
          </Card>
        </Flex>
      </Container>
    </Box>
  );
}
